import { css } from '@emotion/core';
import { mq, variables } from '../../cssInJs';
export default {
  button: css(mq({
    position: 'absolute',
    left: '1rem',
    lineHeight: '1.6rem',
    color: variables.primaryColor, // Austral blue #002c72
    fontSize: ['12px', null, '15px'],
    '&:hover, &:focus': {
      color: variables.secondaryColor, // lt blue #689aca
    }
  })),
}